var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.39002 10.353H17.6C17.7347 10.353 17.864 10.4065 17.9592 10.5018C18.0545 10.5971 18.108 10.7263 18.108 10.861C18.108 10.9958 18.0545 11.125 17.9592 11.2202C17.864 11.3155 17.7347 11.369 17.6 11.369H4.39002C4.25529 11.369 4.12608 11.3155 4.03081 11.2202C3.93554 11.125 3.88202 10.9958 3.88202 10.861C3.88202 10.7263 3.93554 10.5971 4.03081 10.5018C4.12608 10.4065 4.25529 10.353 4.39002 10.353Z",
    fill: "#6A148E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.369 4.39106V17.6011C11.369 17.7358 11.3155 17.865 11.2202 17.9603C11.125 18.0555 10.9957 18.1091 10.861 18.1091C10.7263 18.1091 10.5971 18.0555 10.5018 17.9603C10.4065 17.865 10.353 17.7358 10.353 17.6011V4.39106C10.353 4.25633 10.4065 4.12711 10.5018 4.03185C10.5971 3.93658 10.7263 3.88306 10.861 3.88306C10.9957 3.88306 11.125 3.93658 11.2202 4.03185C11.3155 4.12711 11.369 4.25633 11.369 4.39106Z",
    fill: "#6A148E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21.5499C16.8266 21.5499 21.55 16.8266 21.55 11C21.55 5.17335 16.8266 0.449951 11 0.449951C5.17341 0.449951 0.450012 5.17335 0.450012 11C0.450012 16.8266 5.17341 21.5499 11 21.5499Z",
    stroke: "#6A148E",
    strokeWidth: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.79b0bc75f3cb7cf240267e5c96364baf.svg";
export { ForwardRef as ReactComponent };